module.exports = __webpack_public_path__ + "static/media/transaction_summary.73da9f75.svg";